/* eslint-disable perfectionist/sort-objects */
export const Messages = {
  SOMETHING_WENT_WRONG: 'Ooops, something went wrong',

  DATE_RANGE_ERROR: 'Please select a period not longer than 3 months',
  DATE_REQUIRED_ERROR: 'Please choose a period in the date',
  DATE_NORANGE_ERROR: 'Please choose a period rather than a day',

  ADDED_SUCCESSFULLY: 'has been added successfully',
  UPDATED_SUCCESSFULLY: 'has been updated successfully',
  DELETED_SUCCESSFULLY: 'has been deleted successfully',
  CREATED_SUCCESSFULLY: 'has been created successfully',
  SUBMITTED_SUCCESSFULLY: 'has been submitted successfully',
  SENT_SUCCESSFULLY: 'has been sent successfully',
};
